import { render, staticRenderFns } from "./SearchWidget.vue?vue&type=template&id=ca1ada9a&scoped=true"
import script from "./SearchWidget.vue?vue&type=script&lang=js"
export * from "./SearchWidget.vue?vue&type=script&lang=js"
import style0 from "./SearchWidget.vue?vue&type=style&index=0&id=ca1ada9a&prod&lang=scss"
import style1 from "./SearchWidget.vue?vue&type=style&index=1&id=ca1ada9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1ada9a",
  null
  
)

export default component.exports